module.exports = __webpack_public_path__ + "static/media/dynamodb.5f109dfd.svg";